// extracted by mini-css-extract-plugin
module.exports = {"container":"VariantImages_container__2K28L"};